import React, { useMemo } from 'react';
import { evaluarPassword } from '../../lib/passwordStrength';

/**
 * Indicador visual de fortaleza de contraseña: barra colorida + label +
 * sugerencias específicas. Se monta debajo de cualquier input de password.
 *
 * Si la contraseña está vacía, no renderiza nada (no estorba el form).
 *
 * Props:
 *   password (string): el valor actual del input
 *   showSugerencias (boolean): mostrar lista de cosas a mejorar (default true)
 */
export default function PasswordStrength({ password, showSugerencias = true }) {
  const ev = useMemo(() => evaluarPassword(password), [password]);

  if (!password) return null;

  return (
    <div style={{ marginTop: 8, fontSize: 12 }}>
      {/* Barra */}
      <div style={{
        position: 'relative', height: 4, borderRadius: 2,
        background: 'var(--border-200, #e0ddd6)', overflow: 'hidden',
        marginBottom: 6,
      }}>
        <div style={{
          position: 'absolute', top: 0, left: 0, height: '100%',
          width: `${ev.pct}%`, background: ev.color,
          transition: 'width 0.2s ease, background 0.2s ease',
          borderRadius: 2,
        }} />
      </div>

      {/* Label */}
      {ev.label && (
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'baseline', marginBottom: 4,
        }}>
          <span style={{ color: ev.color, fontWeight: 600 }}>
            {ev.label}
          </span>
        </div>
      )}

      {/* Sugerencias */}
      {showSugerencias && ev.sugerencias?.length > 0 && (
        <ul style={{
          margin: 0, padding: '4px 0 0 16px',
          color: 'var(--ink-500, #888)', fontSize: 11, lineHeight: 1.5,
        }}>
          {ev.sugerencias.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
